import { cn } from "utils/styling";

const VARIANT_STYLES: Record<MessageVariant, string> = {
  error: "text-core-mystic-red-600",
  success: "text-lds-purpose-status-positive",
};

type MessageProps = {
  className?: string;
  message: string;
  variant: MessageVariant;
};

type MessageVariant = "error" | "success";

export const Message = ({ className, message, variant }: MessageProps) => {
  const styles = VARIANT_STYLES[variant];
  return <p className={cn("text-left", styles, className)}>{message}</p>;
};
